import React, { useReducer } from "react";

/**
 *  The context.
 */
export const StepsContext = React.createContext({});

const initialState = {
  state: {
    // In order of execution. Important.
    start: {
      error: false,
      completed: false,
      //      success: false,
    },
    browserDetection: {
      error: false,
      completed: false,
      //      success: false,
      timeoutError: false,
      scanError: false,
    },
    appDetection: {
      error: false,
      completed: false,
      //      success: false,
      timeoutError: false,
      scanError: false,
      cancelError: false,
    },
    // speedTestDetection: {
    //   error: false,
    //   completed: false,
    //   //      success: false,
    //   timeoutError: false,
    //   scanError: false,
    // },
    networkDetection: {
      error: false,
      completed: false,
      //      success: false,
      timeoutError: false,
      scanError: false,
    },
    finish: {
      error: false,
      completed: false,
      //      success: false,
    },
  },

  current: { name: "start", index: 0 },

  // errors: {
  //   browserDetectionTimeout: false,
  //   browserDetectionError: false,
  //   appTimeout: false,
  //   appCancel: false,
  //   appError: false,
  //   speedTestTimeout: false,
  //   speedTestError: false,
  //   networkTestTimeout: false,
  //   networkTestError: false,
  // },
};

// The reducer.

let reducer = (steps, action) => {
  /**
   *  Calculate the next step.
   */
  const nextStep = () => {
    let keys = Object.keys(steps.state);

    let index = keys.indexOf(steps.current.name);
    if (index >= 0) {
      return { name: keys[index + 1], index: index + 1 };
    }
    // Should never happen.
    return { name: keys[0], index: 0 };
  };

  /**
   *  Calculate the previous step.
   */
  const previousStep = () => {
    let keys = Object.keys(steps.state);
    let index = keys.indexOf(steps.current.name);
    if (index > 0) {
      return { name: keys[index - 1], index: index - 1 };
    }
    return { name: keys[0], index: 0 };
  };

  switch (action.type) {
    // Set a completed state.
    case "setCompleted": {
      let obj = steps;
      obj.state[action.payload].completed = true;
      return obj;
    }

    case "setError": {
      let key = Object.keys(action.payload)[0];
      let value = Object.values(action.payload)[0];

      let obj = steps;

      obj.state[key] = { ...obj.state[key], ...action.payload[key], error: true, success: false };

      console.log(`steps state: ${JSON.stringify(steps.state)}`);

      return obj;
    }

    // Next step.
    case "nextStep": {
      let next = nextStep();
      return { ...steps, current: next };
    }

    // Previous step.
    case "previousStep": {
      return { ...steps, current: previousStep() };
    }

    default:
      return steps;
  }
};

/**
 *  The Context Provider.
 */
export const StepsContextProvider = (props) => {
  const [steps, dispatch] = useReducer(reducer, initialState);

  return <StepsContext.Provider value={[steps, dispatch]}>{props.children}</StepsContext.Provider>;
};

// steps: {
//   // In order of execution. Important.
//   start: {
//     completed: false,
//     success: false,
//     error: false,
//     done: false,
//   },
//   browserDetection: {
//     completed: false,
//     success: false,
//     error: false,
//     done: false,
//   },
//   appDetection: {
//     completed: false,
//     success: false,
//     error: false,
//     done: false,
//   },
//   speedTestDetection: {
//     completed: false,
//     success: false,
//     error: false,
//     done: false,
//   },
//   networkDetection: {
//     completed: false,
//     success: false,
//     error: false,
//     done: false,
//   },
//   finish: {
//     completed: false,
//     success: false,
//     error: false,
//     done: false,
//   },
// },
